import React from 'react';
import TableCore from '../TableCore/TabelCore';
import classNames from 'classnames';
import '../TableCore/styles.css';
import styles from './Table.module.scss';
import { DataTableHeader } from './types/DataTableHeader';
import { TranslationService } from '../../services';
import './styles.scss';
import { useAppContext } from '../../../AppContext';
import styled, { css } from 'styled-components';
import { DictionaryType } from '../../types/DictionaryType';

type PaginationPropsType = {
  hideSizePerPage: boolean;
  hidePageListOnlyOnePage: boolean;
  sizePerPage?: number;
};

type Props = {
  headers: DataTableHeader[];
  rows: any[];
  keyField: string;
  paginationProps?: PaginationPropsType;
  expandRow?: any;
  wrapperClassNames?: string;
  className?: string;
  noDataIndication?: () => JSX.Element;
};

const Table = (props: Props) => {
  const context = useAppContext();

  return (
    <TableWrapper styles={context.styles}>
      <TableCore
        data={props.rows}
        noDataIndication={props.noDataIndication || NoDataIndication}
        keyField={props.keyField}
        paginationProps={props.paginationProps}
        expandRow={props.expandRow}
        classes={classNames('c-table', props.className, styles.table)}
        wrapperClasses={classNames(styles.wrapper, props.wrapperClassNames, 'has-h-scrollbar')}
        paginationWrapperClass="c-table-pagination"
        columns={props.headers.map((h) => ({
          dataField: h.columnName,
          text: h.headerName,
          sort: h.isSortColumn || false,
          hidden: !h.isVisible && !h.isVisibleOnMobile,
          classes: () => h.cssClassNames,
          headerClasses: () => h.cssClassNames,
          formatter: h.formatter ? h.formatter : undefined,
          headerFormatter: h.headerFormatter ? h.headerFormatter : undefined,
          formatExtraData: props.rows,
        }))}
      />
    </TableWrapper>
  );
};

const TableWrapper = styled.div<{ styles: DictionaryType<DictionaryType<string>> }>`
  ${(props) => {
    let styles = '';

    if (props.styles) {
      const brandColors = props.styles['general:colors'].brand;
      const paginationModule = props.styles['module:table:pagination'];
      const paginationActiveModule = props.styles['module:table:paginationActive'];

      if (paginationModule && paginationModule.backgroundColor) {
        styles = `ul li.page-item { 
          background: ${paginationModule.backgroundColor} !important;
        } ${styles}`;
      } else if (brandColors) {
        styles = `ul li.page-item { 
          background: ${brandColors.split(',')[0]} !important;
        } ${styles}`;
      }

      if (paginationModule && paginationModule.textColor) {
        styles = `ul li.page-item { color: ${paginationModule.textColor} !important; } ${styles}`;
      }

      if (paginationActiveModule && paginationActiveModule.backgroundColor) {
        styles = `ul li.page-item.active a { background: ${paginationActiveModule.backgroundColor} !important; } ${styles}`;
      }

      if (paginationActiveModule && paginationActiveModule.textColor) {
        styles = `ul li.page-item.active a { color: ${paginationActiveModule.textColor} !important; } ${styles}`;
      }
    }

    return css`
      & {
        ${styles}
      }
    `;
  }}
`;

const NoDataIndication = () => {
  return (
    <div>
      <p>{TranslationService.translate('NoDataTableToDisplay')}</p>
    </div>
  );
};

export default Table;
